import Header from '@/components/index/Header';
import Footer from '@/components/index/Footer';
import styles from './index.module.scss';
export default () => {
  return (
    <div className={styles['deal-container']}>
      <Header />
      <div className={styles['deal-content']}>
        <div className={styles['deal-item']}>
          <p>
            请在使用本网站前仔细阅读这些条款（“条款”）。使用本网站表明您接受这些条款；如果您不接受这些条款，请不要使用本网站。如果您违反任何条款，您的授权将立即终止，您必须立即销毁所有下载或打印的材料。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>网站使用</div>
          <p>
            丹纳赫中国生命科学平台授权您仅出于个人非商业用途查看和下载本网站（“网站”）上的材料，前提是您在材料的任何副本上保留原始材料中包含的所有版权和其他所有权声明。本网站的材料享有版权，也可能受其他法律权利的保护，未经授权使用本网站的任何材料可能会违反适用法律。您不得（1）以任何方式修改本网站的材料或复制、公开展示、演出分发或以任何其他方式将其用于任何公共或商业目的，或（2）以超链接或其他方式提供本网站的任何部分作为另一个网站的一部分。这些条款的目的是在任何其他网站或联网计算机环境中出于任何目的使用这些材料均被禁止。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 网站使用</div>
          <p>
            丹纳赫中国生命科学平台授权您仅出于个人非商业用途查看和下载本网站（“网站”）上的材料，前提是您在材料的任何副本上保留原始材料中包含的所有版权和其他所有权声明。本网站的材料享有版权，也可能受其他法律权利的保护，未经授权使用本网站的任何材料可能会违反适用法律。您不得（1）以任何方式修改本网站的材料或复制、公开展示、演出分发或以任何其他方式将其用于任何公共或商业目的，或（2）以超链接或其他方式提供本网站的任何部分作为另一个网站的一部分。这些条款的目的是在任何其他网站或联网计算机环境中出于任何目的使用这些材料均被禁止。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>链接到外部网站</div>
          <p>
            除法律要求外，Danaher不对您可能通过本网站选择访问的任何其他网站，或在该网站上找到的任何信息、软件或其他产品或材料作任何背书、声明或保证。Danaher提供到这些网站的链接仅为了您的便利，如果您访问这些链接，您将离开本网站并自行承担风险访问这些链接。Danaher不控制这些网站及其内容，除法律要求外，对这些网站及其内容不承担任何责任。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 免责声明和责任限制</div>
          <p>
            本网站提供的材料“按现状”提供，不提供任何形式的保证，包括质量、可销售性、特定用途适用性或不侵犯知识产权的保证。在任何情况下，无论是因使用、无法使用本网站，或因使用本网站、任何链接到本网站的网站，或任一或所有此类网站中包含的材料或信息而产生的结果，丹纳赫、其任何运营公司、或在本网站提及的任何第三方均不对任何直接、间接、偶然、特殊或相应而产生的损害承担责任（包括但不限于因利润损失、数据丢失或业务中断所造成的损失）。适用的法律可能不允许排除附带或相应产生的损害赔偿和/或排除暗示的陈述和保证，因此上述的部分或全部排除可能不适用于您。此外，丹纳赫不保证（1）本网站或其服务器免费于错误、病毒、蠕虫或“特洛伊木马”，或（2）本网站材料的准确性和完整性。本网站的材料可能已过时，除法律要求外，丹纳赫不承诺更新本网站的材料。此外，丹纳赫可随时在不事先通知的情况下对本网站的材料进行更改。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>用户提交</div>
          <p>
            您禁止向本网站传输或从本网站传输任何违反任何法律的材料。您向本网站传输的一切信息或联系将被视为非机密和非专有的，丹纳赫可以自由地将此类材料用于任何目的。特别是，丹纳赫可能会以硬拷贝格式和电子媒介形式，以及丹纳赫全球其他分部的数据库中存储您的个人身份信息，这一切都受我们的隐私政策约束。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>适用法律</div>
          <p>
            丹纳赫从美国管理本网站，并不表示或保证本网站的材料在美国之外适用或可用。从法律禁止此类内容的司法管辖区访问本网站及其内容是被禁止的，您不得使用、出口或重新出口本网站的内容或任何副本或改编，以违反任何适用的法律或法规，包括但不限于美国出口法律和法规。如果您在美国之外访问本网站，您应自行负责遵守相应的当地法律。此外，本网站上发布的信息可能会提及在您的国家/地区不可用的产品、程序或服务。这些条款将受特拉华州法律的管辖，并根据该等法律进行解释，而不考虑法律冲突原则。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}> 一般性</div>
          <p>
            丹纳赫可随时通过更新本通告来修订这些条款。您应不时访问此页面以查看更新的条款，因为其所具备的约束力。这些条款的某些规定可能被明确指定的法律通知或位于本网站特定页面上的条款所取代。
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};
